import React from 'react';

import { AnalysisWorkspaceSurface } from '../FmAnalysisWorkspaceRoot';
import { FmFormFlowDialog } from '../FmFormFlowDialog';
import { FmModal } from '../FmModal';
import { OperationalWorkspaceSurface } from '../FmOperationalWorkspaceRoot';
import type { FmMapWorkspaceDescriptor } from '../FmMapWorkspaceRoot.types';

/** Nested capabilities whose descriptors were validated by the map archetype. */
export const MapWorkspaceDialogs: React.FC<{
  descriptor: FmMapWorkspaceDescriptor;
}> = ({ descriptor }) => (
  <>
    {(descriptor.dialogs ?? []).map((dialog) => {
      const onClose = () =>
        descriptor.onEvent?.({
          kind: 'dialog-dismiss',
          dialogId: dialog.id,
        });
      if (dialog.kind === 'operational-detail') {
        return (
          <FmModal
            key={dialog.id}
            open={dialog.open}
            title={dialog.title}
            cancelText={dialog.closeLabel}
            onCancel={onClose}
            footer={null}
            size={dialog.size}
            data-testid={`map-dialog-${dialog.id}`}
          >
            <OperationalWorkspaceSurface
              descriptor={dialog.workspace}
              presentation="dialog"
              data-testid={`${dialog.id}-workspace`}
            />
          </FmModal>
        );
      }
      if (dialog.kind === 'analysis-detail') {
        return (
          <FmModal
            key={dialog.id}
            open={dialog.open}
            title={dialog.title}
            cancelText={dialog.closeLabel}
            onCancel={onClose}
            footer={null}
            size={dialog.size}
            data-testid={`map-dialog-${dialog.id}`}
          >
            <AnalysisWorkspaceSurface
              descriptor={dialog.workspace}
              presentation="map-detail"
              data-testid={`${dialog.id}-workspace`}
            />
          </FmModal>
        );
      }
      return (
        <FmFormFlowDialog
          key={dialog.id}
          open={dialog.open}
          title={dialog.title}
          closeLabel={dialog.closeLabel}
          size={dialog.size}
          descriptor={dialog.flow}
          closeConfirmation={dialog.closeConfirmation}
          onClose={onClose}
          data-testid={`map-dialog-${dialog.id}`}
        />
      );
    })}
  </>
);

MapWorkspaceDialogs.displayName = 'MapWorkspaceDialogs';
